import React from 'react';
import { connect } from 'react-redux';
import { compose, withPropsOnChange } from 'recompose';
import _ from 'lodash';
import { getEntities } from 'dash-front/selectors';
import { fetchUsers } from 'dash-front/admin/actions/accounts';
import { fetchAllCampaigns } from 'dash-front/admin/actions/campaigns';
import { POST_STATUS } from 'dash-front/constants';
import { responseStatusIsOk, toIdArray, addToQuery, safeParse } from 'dash-front/helpers';
import styled from 'styled-components';
import { Checkbox, RadioButton, RadioButtonGroup } from 'material-ui';
const withAdmin = withPropsOnChange('user', ({ user }) => ({
    isAdmin: user && Array.isArray(user.roles) && user.roles.indexOf('admin') > -1
}));

const getSelectedValues = qsVal => {
    const parsed = safeParse(qsVal);
    return Array.isArray(parsed) ? parsed : [];
};

const Title = styled.div`
    color: #3f51b5;
    font-size: 24px;
    line-height: 28px;
    padding: 18px 15px;
    background: #f9f9f9;
`;

const Block = styled.div`
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    margin-left: 17px;
    padding: 12px 10px 12px 0;
    .title {
        color: #9b9b9b;
        font-size: 18px;
        margin-bottom: 10px;
    }
    .subtitle {
        color: #9b9b9b;
        font-weight: 700;
        margin: 15px 0 15px;
        font-size: 16px;
    }
`;

class Filters extends React.PureComponent {
    componentDidMount() {
        const { isAdmin, dispatch } = this.props;
        console.log('is admin', isAdmin);
        dispatch(fetchUsers())
            .then(res => {
                if (isAdmin) {
                    if (responseStatusIsOk(res.status)) {
                        const userIds = toIdArray(res.body);
                        this.setState({ userIds }, () => {
                            if (
                                !getSelectedValues(this.props.selectedUsers).length ||
                                !getSelectedValues(this.props.selected).length
                            ) {
                                addToQuery('users', JSON.stringify(userIds));
                            }
                            return;
                        });
                    }
                } else {
                    return;
                }
            })
            .then(() => {
                dispatch(fetchAllCampaigns()).then(res => {
                    if (responseStatusIsOk(res.status)) {
                        const ids = toIdArray(res.body);
                        this.setState({ ids }, () => {
                            if (!getSelectedValues(this.props.selected).length) {
                                this.onChange(null, null, ids);
                            }
                        });
                    }
                });
            });
    }

    state = { ids: null };

    onChange = (e, i, values) => {
        addToQuery('campaigns', JSON.stringify(values));
    };

    onCampaignCheck = (ids, isChecked) => {
        const { selected: dirtyValues, campaigns } = this.props;
        let selected = this.getChangedArray(ids, isChecked, dirtyValues);

        let affectedUsers = selected.map(id => campaigns[id].userId);

        if (isChecked) {
            let newUsers = this.getChangedArray(affectedUsers, isChecked, this.props.selectedUsers);
            addToQuery('users', JSON.stringify(newUsers));
        }
        this.onChange(null, null, selected);
    };

    onUserCheck = (ids, isChecked) => {
        const { campaigns, selected: selectedCampaignsDirtyValues } = this.props;

        let selected = this.getChangedArray(ids, isChecked, this.props.selectedUsers);

        let selectedCampaigns = getSelectedValues(selectedCampaignsDirtyValues);
        if (isChecked) selectedCampaigns = _.map({ ...campaigns }, campaign => campaign._id);

        let affectedCampaigns = _.compact(
            selectedCampaigns.map(s => campaigns[s]).map(campaign => {
                if (ids.includes(campaign.userId)) {
                    return campaign._id;
                }
            })
        );

        this.onCampaignCheck(affectedCampaigns, isChecked);
        addToQuery('users', JSON.stringify(selected));
    };

    onStatusCheck = (ids, isChecked) => {
        const { selectedStatuses: selectedStatusesDirtyValues } = this.props;

        let newStatuses = ids; // this.getChangedArray(ids, isChecked,selectedStatusesDirtyValues)
        if (newStatuses[0] === 'all') newStatuses = [];
        addToQuery('statuses', JSON.stringify(newStatuses));
    };

    getChangedArray = (ids, isChecked, dirtyValues) => {
        let selected = getSelectedValues(dirtyValues);
        if (!isChecked) _.pullAll(selected, ids);
        else selected = _.uniq([...selected, ...ids]);
        return selected;
    };

    render() {
        const {
            campaigns,
            isAdmin,
            selected: dirtyValues,
            selectedUsers: dirtyValuesSelectedUsers,
            selectedStatuses: dirtyValuesSelectedStatuses
        } = this.props;

        let users = isAdmin
            ? _.uniqBy(
                  _.map(campaigns, campaign => {
                      return this.props.users[campaign.userId];
                  }),
                  '_id'
              )
            : [];

        const selected = getSelectedValues(dirtyValues);
        const selectedUsers = getSelectedValues(dirtyValuesSelectedUsers);
        const selectedStatuses = getSelectedValues(dirtyValuesSelectedStatuses);

        let campaignsArray = _.map(campaigns, c => c);
        let campaignsGroupedByUser = _.groupBy(campaignsArray, 'userId');

        return (
            <div style={{ paddingBottom: 40 }}>
                <Title>Filters</Title>
                {isAdmin && (
                    <Block>
                        <div className="title">Clients</div>
                        {users.map(user => (
                            <Checkbox
                                onCheck={(e, isChecked) => this.onUserCheck([_.get(user, ['_id'])], isChecked)}
                                checked={selectedUsers && selectedUsers.indexOf(_.get(user, ['_id'])) > -1}
                                key={_.get(user, ['_id'])}
                                label={`${_.get(user, 'username')} (${_.get(user, 'client')})`}
                            />
                        ))}
                    </Block>
                )}
                <Block>
                    <div className="title">Campaigns</div>
                    {_.map(campaignsGroupedByUser, (campaigns, user) => (
                        <div key={user}>
                            {isAdmin && <div className="subtitle">{_.get(this.props.users, [user, 'username'])}</div>}
                            {_.map(campaigns, campaign => (
                                <Checkbox
                                    onCheck={(e, isChecked) => this.onCampaignCheck([campaign._id], isChecked)}
                                    checked={selected && selected.indexOf(campaign._id) > -1}
                                    label={campaign.title}
                                    key={campaign._id}
                                />
                            ))}
                        </div>
                    ))}
                </Block>
                <Block>
                    <div className="title">Status</div>
                    <RadioButtonGroup
                        name="status"
                        defaultSelected={selectedStatuses && selectedStatuses[0]}
                        onChange={(e, value) => this.onStatusCheck([value], true)}
                    >
                        {[
                            { label: 'All', value: 'all' },
                            {
                                label: 'Waiting for moderation',
                                value: POST_STATUS.AWAITING
                            },
                            { label: 'Published', value: POST_STATUS.PUBLISHED },
                            { label: 'Not published', value: POST_STATUS.NOT_PUBLISHED },
                            { label: 'Failed', value: POST_STATUS.FAILED },
                            { label: 'Rejected', value: POST_STATUS.REJECTED },
                            { label: 'In progress', value: POST_STATUS.IN_PROGRESS }
                        ].map(({ label, value }) => (
                            <RadioButton
                                // onCheck={(e, isChecked) => this.onStatusCheck([value], isChecked)}
                                // checked={selectedStatuses && selectedStatuses.indexOf(value) > -1}
                                label={label}
                                key={value}
                                value={value}
                            />
                        ))}
                    </RadioButtonGroup>
                </Block>
            </div>
        );
    }
}

export default compose(
    connect(
        state => ({
            users: getEntities(state).users,
            user: state.user,
            campaigns: getEntities(state).campaignsList,
            selected: _.get(state.routing, ['location', 'query', 'campaigns']),
            selectedUsers: _.get(state.routing, ['location', 'query', 'users']),
            selectedStatuses: _.get(state.routing, ['location', 'query', 'statuses'])
        }),
        null
    ),
    withAdmin
)(Filters);



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/components/Hub/Filters.js
 **/